"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyAgreementField = CompanyAgreementField;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const SendResumeFields_style_1 = require("./SendResumeFields.style");
function CompanyAgreementField({ agreementRules, companyName, setIsPersonalAgreementByCompanyVisible }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row", children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: "companyAgreement", rules: agreementRules, valuePropName: "checked", children: (0, jsx_runtime_1.jsxs)(antd_1.Checkbox, { children: [(0, jsx_runtime_1.jsx)(SendResumeFields_style_1.RedText, { children: "*" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.accept_personal_information_by_company", values: {
                                companyName,
                            } })] }) }), (0, jsx_runtime_1.jsx)(SendResumeFields_style_1.QuestionMarkWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.QuestionMark, { onClick: () => setIsPersonalAgreementByCompanyVisible(true) }) })] }));
}
